import React from 'react';
import api from '../services/api';
import { saveSession } from '../services/auth';
import travelBg from '../assets/travel-bg.svg';

class Login extends React.Component {
  state = {
    email: '',
    password: '',
    error: '',
    loading: false,
    showPassword: false
  };

  toggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ error: '', loading: true });
    try {
      const res = await api.post('/auth/login', {
        email: this.state.email,
        password: this.state.password
      });
      saveSession(res.data.token, res.data.user);
      this.props.onLoginSuccess();
    } catch (err) {
      const message = err.response?.data?.message || 'Unable to sign in. Please try again.';
      this.setState({ error: message });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { email, password, error, loading } = this.state;
    return (
      <div className="login-screen" style={{ backgroundImage: `url(${travelBg})` }}>
        <div className="login-tagline">
          <div className="eyebrow">Kabra Travel Services</div>
          <h2>Every booking, billed right.</h2>
          <p>Generate GST-compliant hotel and travel invoices in minutes — across every state your company operates in.</p>
        </div>

        <div className="login-card">
          <p className="login-brand">KTS Invoice System</p>
          <p className="login-sub">Kabra Travel Services</p>

          {error && <div className="error-banner">{error}</div>}

          <form onSubmit={this.handleSubmit}>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={this.handleChange}
                autoComplete="username"
                required
              />
            </div>
            <div className="field">
              <label htmlFor="password">Password</label>
              <div className="password-input-wrap">
                <input
                  id="password"
                  name="password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={this.handleChange}
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={this.toggleShowPassword}
                  aria-label={this.state.showPassword ? 'Hide password' : 'Show password'}
                  tabIndex={-1}
                >
                  {this.state.showPassword ? (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.6 18.6 0 0 1 5.06-5.94M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a18.6 18.6 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </svg>
                  ) : (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  )}
                </button>
              </div>
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default Login;